import React from "react";
import { Pagination, Grid, Column } from "./styles";

const Controls = (props) => {
  return (
    <Grid columns={1}>
      <Column>
        <Pagination
          page={props.page}
          onChange={props.handleChange}
          count={props.pages}
          shape="rounded"
        />
      </Column>
    </Grid>
  );
};

export default Controls;
